import state from '@/taskpane/state/sidebar-state'
import office from '@/taskpane/officejs/office-wrapper'
import sendItemOpenMessage from './messages/send-item-open-message'

export default async function addItemChangeListener() {
  office.handlers.add(Office.EventType.ItemChanged, () => {
    state.itemChangedHandlerCount++
    state.currentItem.resetState()

    if (state.sidebarIsConnected && state.sidebarIsAuthenticated) {
      const localItemChangeHandlerCount = state.itemChangedHandlerCount
      setTimeout(() => {
        if (localItemChangeHandlerCount === state.itemChangedHandlerCount) {
          sendItemOpenMessage()
        }
      }, 250)
    }
  })
}
